const categoryBenefitsMap = {
  'Compensation Potential': { icon: '💰', label: 'Compensation Potential' },
  'Equity Potential': { icon: '📈', label: 'Equity Potential' },
  'Formal Roles': { icon: '💼', label: 'Formal Roles' },
  Perks: { icon: '🎁', label: 'Perks' },
  '1-Year Board Member Plaque': {
    icon: '🏆',
    label: '1-Year Board Member Plaque',
  },
  'Board Meeting Speaker Recognition': {
    icon: '💬',
    label: 'Board Meeting Speaker Recognition',
  },
  'Advisory Board Affiliation': {
    icon: '💼',
    label: 'Advisory Board Affiliation',
  },
  '3-Year Featured Advisor Award': {
    icon: '🏆',
    label: '3-Year Featured Advisor Award',
  },
  'Advisor Rate Opportunity': { icon: '💰', label: 'Advisor Rate Opportunity' },
  '$1k Golden Idea Bonus': { icon: '💰', label: '$1k Golden Idea Bonus' },
  '1% Equity Pledge': { icon: '📈', label: '1% Equity Pledge' },
  'Board Member Discount': { icon: '📈', label: 'Board Member Discount' },
  'Complimentary Product': { icon: '📈', label: 'Complimentary Product' },
  'FavorBonds Grant ($300 Value)': {
    icon: '💲',
    label: 'FavorBonds Grant ($300 Value)',
  },
};

module.exports = categoryBenefitsMap;
